import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "@/views/home/E404";
import store from "@/store/store";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "",
    component: () => import("@/views/index/Index"),
    children: [
      {
        path: "/",
        name: "官网",
        component: () => import("@/views/index/Page"),
      },
      {
        path: "/page",
        name: "页面",
        component: () => import("@/views/index/Page"),
      },
      {
        path: "/article",
        name: "文章页面",
        component: () => import("@/views/index/Article"),
      },
    ]
  },
  {
    path: "/saas",
    name: "企业管理平台",
    component: () => import("@/views/login/Login"),
  },
  {
    path: "/saas/wxbind",
    name: "关联微信",
    component: () => import("@/views/home/Wxbind"),
  },
  {
    path: "/saas/wxlogin",
    name: "微信登录",
    component: () => import("@/views/home/Wxlogin"),
  },
  {
    path: "/admin",
    name: "后台管理",
    component: () => import("@/views/login/Admin"),
  },
  {
    path: "/register",
    name: "企业注册",
    component: () => import("@/views/login/Register"),
  },
  {
    path: "/wechat",
    name: "微信小程序设置",
    component: () => import("@/views/wechat/index"),
  },
  {
    path: "",
    name: "Admin",
    component: () => import("@/layouts/AdminBasics"),
    children: [
      /*************主页基础************/
      {
        path: "/home",
        name: "数据报表",
        component: () => import("@/views/home/Home"),
      },
      {
        path: "/home/password",
        name: "修改密码",
        component: () => import("@/views/home/Password"),
      },
      /*************主页基础 end************/
      /*************微信公众号************/
      {
        path: "/wx/mp/info",
        name: "公众号信息",
        component: () => import("@/views/wx/mp/Info"),
      },
      /*************微信公众号end************/
      /*************系统设置************/
      {
        path: "/sys/role",
        name: "角色列表",
        component: () => import("@/views/sys/role/List"),
      },
      {
        path: "/sys/role/edit",
        name: "角色编辑",
        component: () => import("@/views/sys/role/Edit"),
      },
      {
        path: "/sys/user",
        name: "用户列表",
        component: () => import("@/views/sys/user/List"),
      },
      {
        path: "/sys/user/edit",
        name: "用户编辑",
        component: () => import("@/views/sys/user/Edit"),
      },
      {
        path: "/sys/log",
        name: "系统日志",
        component: () => import("@/views/sys/log/List"),
      },
      {
        path: "/sys/domain",
        name: "自定义域名",
        component: () => import("@/views/sys/domain/Info"),
      },
      {
        path: "/sys/openanaccount",
        name: "拉卡拉开户",
        component: () => import("@/views/openanaccount/index"),
      },
      {
        path: "/weapp/regionlimit",
        name: "用户地区限制",
        component: () => import("@/views/weapp/regionlimit/Info"),
      },
      {
        path: "/community/set",
        name: "便民信息设置",
        component: () => import("@/views/community/set/Set"),
      },
      {
        path: "/community/list",
        name: "信息管理",
        component: () => import("@/views/community/list/list"),
      },
      {
        path: "/community/detail",
        name: "信息详情",
        component: () => import("@/views/community/apply/Detail"),
      },
      /*************系统设置end************/
      /*************企业信息************/
      {
        path: "/company_examine_info",
        name: "企业信息",
        component: () => import("@/views/company/examine/Edit"),
      },
      /*************企业信息end************/
      /*************内容中心************/
      {
        path: "/content/class",
        name: "内容分类",
        component: () => import("@/views/content/class/List"),
      },
      {
        path: "/content/gather",
        name: "合集管理",
        component: () => import("@/views/content/gather/List"),
      },
      {
        path: "/content/gather/edit",
        name: "合集编辑",
        component: () => import("@/views/content/gather/Edit"),
      },
      {
        path: "/content",
        name: "内容管理",
        component: () => import("@/views/content/content/List"),
      },
      {
        path: "/content/edit",
        name: "内容编辑",
        component: () => import("@/views/content/content/Edit"),
      },
      {
        path: "/content/share",
        name: "视听共享列表",
        component: () => import("@/views/content/share/ShareList"),
      },
      {
        path: "/content/gather/share",
        name: "共享管理",
        component: () => import("@/views/content/gathershare/ShareList"),
      },
      {
        path: "/content/share/myusageedit",
        name: "我使用的编辑",
        component: () => import("@/views/content/share/MyusageEdit"),
      },
      {
        path: "/content/share/myshareedit",
        name: "我的共享",
        component: () => import("@/views/content/share/MyshareEdit"),
      },
      {
        path: "/grass/share/myshareedit",
        name: "我的共享",
        component: () => import("@/views/content/share/shareGrassDetail"),
      },
      {
        path: "/content/gathershare/myshareedit",
        name: "我的共享查看",
        component: () => import("@/views/content/gathershare/MyshareEdit"),
      },
      {
        path: "/content/gather/share/edit",
        name: "共享合集编辑",
        component: () => import("@/views/content/gather/ShareEdit"),
      },
      {
        path: "/content/share/edit",
        name: "共享内容编辑",
        component: () => import("@/views/content/content/ShareEdit"),
      },
      /*************内容中心end************/

      /*************内容中心_new************/
      {
        path: "/content/class/new",
        name: "内容分类",
        component: () => import("@/views/contentnew/class/List"),
      },
      {
        path: "/content/gather/new",
        name: "合集管理",
        component: () => import("@/views/contentnew/gather/List"),
      },
      {
        path: "/content/gather/reship",
        name: "合集申请转载",
        component: () => import("@/views/contentnew/gather/reship"),
      },
      {
        path: "/content/gather/edit/new",
        name: "合集编辑",
        component: () => import("@/views/contentnew/gather/Edit"),
      },
      {
        path: "/content/new",
        name: "内容管理",
        component: () => import("@/views/contentnew/content/List"),
      },
      {
        path: "/content/reship",
        name: "内容申请转载",
        component: () => import("@/views/contentnew/content/reship"),
      },
      {
        path: "/content/edit/new",
        name: "内容编辑",
        component: () => import("@/views/contentnew/content/Edit"),
      },
      {
        path: "/content/selectclass",
        name: "内容分类选择",
        component: () => import("@/views/contentnew/class/selectclass"),
      },
      {
        path: "/content/recommend",
        name: "种草管理",
        component: () => import("@/views/contentnew/recommend/List"),
      },
      {
        path: "/content/recommend/reship",
        name: "种草申请转载",
        component: () => import("@/views/contentnew/recommend/reship"),
      },
      {
        path: "/content/recommend/edit/new",
        name: "种草编辑",
        component: () => import("@/views/contentnew/recommend/Edit"),
      },
      {
        path: "/community/selectclass",
        name: "信息分类选择",
        component: () => import("@/views/community/class/selectclass"),
      },
      /*************内容中心_new_end************/

      /*************微信小程序************/
      {
        path: "/weapp/basicsset",
        name: "基础设置",
        component: () => import("@/views/weapp/basicsset/Edit"),
      },
      {
        path: "/weapp/menu",
        name: "导航设置",
        component: () => import("@/views/weapp/menu"),
      },
      {
        path: "/weapp/class",
        name: "分类管理",
        component: () => import("@/views/weapp/class"),
      },
      // {path: '/weapp/modular', name: '模块列表', component: () => import('@/views/weapp/modular/List')},
      // {path: '/weapp/modular/edit', name: '模块编辑', component: () => import('@/views/weapp/modular/Edit')},
      {
        path: "/weapp/page",
        name: "页面列表",
        component: () => import("@/views/weapp/page/List"),
      },
      {
        path: "/weapp/page/edit",
        name: "页面编辑",
        component: () => import("@/views/weapp/page/Edit"),
      },
      {
        path: "/weapp/rankingregion",
        name: "排行地区",
        component: () => import("@/views/weapp/rankingregion/Info"),
      },
      /*************微信小程序end************/
      /*************用户管理************/
      {
        path: "/user/member",
        name: "会员列表",
        component: () => import("@/views/user/member/List"),
      },
      {
        path: "/user/blackuser",
        name: "黑名单用户列表",
        component: () => import("@/views/user/member/Blackuser"),
      },
      {
        path: "/user/agreement",
        name: "会员协议",
        component: () => import("@/views/user/Agreement"),
      },
      /*************用户管理end************/
      /*************直播管理************/
      {
        path: "/broadcast/audio",
        name: "音频直播",
        component: () => import("@/views/broadcast/audio/List"),
      },
      {
        path: "/broadcast/audio/edit",
        name: "音频直播编辑",
        component: () => import("@/views/broadcast/audio/Edit"),
      },
      {
        path: "/broadcast/video",
        name: "视频直播",
        component: () => import("@/views/broadcast/video/List"),
      },
      {
        path: "/broadcast/video/edit",
        name: "视频直播编辑",
        component: () => import("@/views/broadcast/video/Edit"),
      },
      {
        path: "/broadcast/weapp",
        name: "小程序直播",
        component: () => import("@/views/broadcast/weapp/Info"),
      },
      {
        path: "/broadcast/hikvision",
        name: "监控直播流",
        component: () => import("@/views/broadcast/hikvision/Info"),
      },
      /*************直播管理end************/
      // 商城
      {
        path: "/goods/brand",
        name: "商品配置",
        component: () => import("@/views/goods/brand/list"),
      },
      {
        path: "/goods/class",
        name: "商品分类",
        component: () => import("@/views/goods/class/list"),
      },
      {
        path: "/goods/selectclass",
        name: "商品分类选择",
        component: () => import("@/views/goods/class/selectclass"),
      },
      {
        path: "/goods/specifications",
        name: "规格管理",
        component: () => import("@/views/goods/specifications/list"),
      },
      {
        path: "/lottery/index",
        name: "抽奖活动",
        component: () => import("@/views/lottery/index"),
      },
      {
        path: "/lottery/edit",
        name: "抽奖活动",
        component: () => import("@/views/lottery/Edit"),
      },
      {
        path: "/appointment/index",
        name: "预约活动",
        component: () => import("@/views/appointment/index"),
      },
      {
        path: "/appointment/edit",
        name: "预约活动",
        component: () => import("@/views/appointment/Edit"),
      },
      {
        path: "/chargecard/index",
        name: "充值卡管理",
        component: () => import("@/views/chargecard/index"),
      },
      {
        path: "/chargecard/goldbeandetail",
        name: "金豆统计数据",
        component: () => import("@/views/chargecard/GoldBeansDetail"),
      },
      {
        path: "/chargecard/edit",
        name: "充值卡管理",
        component: () => import("@/views/chargecard/Edit"),
      },
      {
        path: "/cashier/index",
        name: "收款码管理",
        component: () => import("@/views/cashier/index"),
      },
      {
        path: "/goods/list",
        name: "商品管理",
        component: () => import("@/views/goods/list/list"),
      },
      {
        path: "/goods/share/apply",
        name: "申请分销",
        component: () => import("@/views/goods/share/ApplyShare"),
      },
      {
        path: "/goods/share/myshareedit",
        name: "我的商品分享编辑",
        component: () => import("@/views/goods/share/MyshareEdit"),
      },
      {
        path: "/goods/share/myusageedit",
        name: "我商品分享使用的编辑",
        component: () => import("@/views/goods/share/MyusageEdit"),
      },
      {
        path: "/goods/premiumfreight",
        name: "额外运费模版",
        component: () => import("@/views/goods/premiumfreight/list"),
      },
      {
        path: "/goods/premiumfreight/edit",
        name: "额外运费模版编辑",
        component: () => import("@/views/goods/premiumfreight/Edit"),
      },
      {
        path: "/goods/delivermanager/edit",
        name: "自提点编辑",
        component: () => import("@/views/goods/delivermanager/Edit"),
      },
      {
        path: "/goods/suppliermanager/edit",
        name: "供货商编辑",
        component: () => import("@/views/goods/suppliermanager/Edit"),
      },
      {
        path: "/goods/suppliermanager/address",
        name: "供货商退货地址",
        component: () => import("@/views/goods/suppliermanager/address"),
      },
      {
        path: "/goods/salesreturn/edit",
        name: "退货地址编辑",
        component: () => import("@/views/goods/salesreturn/Edit"),
      },
      {
        path: "/goods/contact/edit",
        name: "联系人",
        component: () => import("@/views/goods/contact/Edit"),
      },
      {
        path: "/goods/share",
        name: "商品共享列表",
        component: () => import("@/views/goods/share/ShareList"),
      },
      {
            path: "/goods/order",
            name: "商品订单",
            component: () => import("@/views/goods/order/index"),
        },
      {
        path: "/goods/drawback",
        name: "退款管理",
        component: () => import("@/views/goods/drawbackApply/index"),
      },
      {
        path: "/goods/list/edit",
        name: "商品详情",
        component: () => import("@/views/goods/list/edit"),
      },
      {
        path: "/goods/coupon",
        name: "优惠券",
        component: () => import("@/views/goods/coupon/List"),
      },
      {
        path: "/goods/coupon/edit",
        name: "优惠券详情",
        component: () => import("@/views/goods/coupon/Edit"),
      },
      {
        path: "/goods/broadcastlist",
        name: "直播商品库",
        component: () => import("@/views/goods/broadcast/list"),
      },
      {
        path: "/transaction/basic",
        name: "交易基础配置",
        component: () => import("@/views/transaction/basic/set"),
      },
      {
        path: "/order",
        name: "订单管理",
        component: () => import("@/views/order/list"),
      },
      {
        path: "/order/info",
        name: "订单详情",
        component: () => import("@/views/order/info"),
      },
      {
        path: "/orderbill",
        name: "分账列表",
        component: () => import("@/views/orderbill/list"),
      },
      {
        path: "/orderbill/info",
        name: "分账详情",
        component: () => import("@/views/orderbill/info"),
      },
      {
        path: "/afterorders",
        name: "售后管理",
        component: () => import("@/views/afterorders/list"),
      },
      {
        path: "/afterorders/info",
        name: "售后详情",
        component: () => import("@/views/afterorders/info"),
      },
      /*************投票************/
      {
        path: "/markettool/vote",
        name: "投票",
        component: () => import("@/views/vote/List"),
      },
      {
        path: "/markettool/vote/edit",
        name: "投票编辑",
        component: () => import("@/views/vote/Edit"),
      },
      /*************投票end************/
      /*************问卷************/
      {
        path: "/markettool/questionnaire",
        name: "活动问卷",
        component: () => import("@/views/questionnaire/List"),
      },
      {
        path: "/markettool/questionnaire/edit",
        name: "问卷编辑",
        component: () => import("@/views/questionnaire/Edit"),
      },
      {
        path: "/markettool/questionnaire/member/List",
        name: "报名列表",
        component: () => import("@/views/questionnaire/memberList"),
      },
      /*************问卷end************/
      {
        path: "/markettool/memberquestion",
        name: "会员注册问卷",
        component: () => import("@/views/memberquestion/List"),
      },
      {
        path: "/markettool/memberquestion/edit",
        name: "问卷编辑",
        component: () => import("@/views/memberquestion/Edit"),
      },
      {
        path: "/markettool/memberquestion/member/List",
        name: "会员信息",
        component: () => import("@/views/memberquestion/memberList"),
      },
      {
        path: "/markettool/memberquestion/member/memberSet",
        name: "会员设置",
        component: () => import("@/views/memberquestion/memberSet"),
      },
      /*************成长体系管理************/
      {
        path: "/weapp/member",
        name: "成长体系管理",
        component: () => import("@/views/weapp/member/index"),
      },
      /*************积分配置管理************/
      {
        path: "/weapp/integral",
        name: "积分配置管理",
        component: () => import("@/views/weapp/integral/index"),
      },
      /*************官网设置************/
      {
        path: "/website/basic",
        name: "官网基础设置",
        component: () => import("@/views/website/basic/Info"),
      },
      {
        path: "/website/pages",
        name: "官网页面",
        component: () => import("@/views/website/pages/List"),
      },
      {
        path: "/website/pages/edit",
        name: "官网页面-编辑",
        component: () => import("@/views/website/pages/Edit"),
      },
      {
        path: "/website/guestbook",
        name: "留言板",
        component: () => import("@/views/website/guestbook/List"),
      },
      {
        path: "/seckill/pages",
        name: "秒杀活动",
        component: () => import("@/views/seckillmanager/list"),
      },
      {
        path: "/seckill/edit",
        name: "秒杀活动编辑",
        component: () => import("@/views/seckillmanager/Edit"),
      },
      /*************官网设置************/
    ],
  },
  { path: "*", name: "NotFound", component: NotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  store.commit("setIsScroll", false);
  next();
});

export default router;
